module.exports = __webpack_public_path__ + "static/media/it-stock-logo.0aec28bf.png";